import multiSelect from "./MultiSelect";

export default multiSelect;
